export class TypeGuards {
  static isNonEmptyString(value: unknown): value is string {
    return typeof value === 'string' && value.trim().length > 0;
  }

  static isBoolean(value: unknown): value is boolean {
    return typeof value === 'boolean';
  }

  static isDate(value: unknown): value is Date {
    return value instanceof Date && !Number.isNaN(value.getTime());
  }
}
